import { SAVE_CHATS_STATISTICS, CLEAR_CHATS_STATISTICS } from '../actions/chatsStatistics'

const chatsStatistics = (state = null, action) => {
  if (action.type === SAVE_CHATS_STATISTICS) {
    return action.stats
  } else if (action.type === CLEAR_CHATS_STATISTICS) {
    return null
  }
  return state
}

export default chatsStatistics
